import * as React from "react";
import { CheckboxGroupFieldSchema } from "@generation/core";
import { ItemValue } from "../Components/ItemValue";
import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";
import { withRenderFieldHoc } from "../Hoc/withRenderFieldHoc";
import { useDataContext, getArrayValueFromObject } from "@generation/overview-core";
import "./CheckboxGroupField.scss";

interface ICheckboxGroupFieldProps {
  field: CheckboxGroupFieldSchema;
  name: string;
}

export const CheckboxGroupField = withHideOnFieldHoc(
  withRenderFieldHoc((props: ICheckboxGroupFieldProps): JSX.Element => {
    const value = getArrayValueFromObject(useDataContext(), props.name);
    

    if (!value) {
      return <ItemValue value="-" />;
    }

    return (
      <ul className="checkbox-group-list">
        {value.map((item, idx) => {
          const labelItemValue = props.field.options.find((optionItem) => {
              return optionItem.value == item })?.label ?? item;

          return (
            <li key={idx}>
              <ItemValue value={labelItemValue} />
            </li>
            );
        })}
      </ul>
    );
  })
);
